<script lang="ts">
    export let blured: boolean = false;
    export let imagePath: string;
    export let pointer: boolean = false;
    export let zoomable: boolean = false;
</script>

<div on:click class="card {zoomable ? 'zoomable' : ''}" style="background: url({imagePath}) center/cover no-repeat; cursor: {pointer ? 'pointer': 'cursor'};">
    <div class="{blured ? 'cardFilter' : ''}">
        <slot></slot>
    </div>
</div>

<style type="text/scss">
    .card {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border-radius: 20px;
        border: 1px solid white;
        background: white;
        width: 200px;
        height: 200px;
        margin-right: 1rem;
        color: white;
        transition: .3s;

        @media (max-width: 768px) {
            margin: {
                right: 0;
                bottom: 1rem;
            }
        }

        &Filter {
            backdrop-filter: blur(2px) brightness(0.9);
            height: 100%;
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            border-radius: 21px;
            text-align: center;
        }

        &:last-of-type {
            margin-right: 0;
        }

        &.zoomable {
            &:hover {
                transition: .3s;
                transform: scale(1.05);
            }
        }
    }
</style>